import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './TextInput.module.sass';

const TextInput = ({ val = '', onChange, type = 'text', label = '', placeholder = '', fullWidth = false, required = false, error, onFocus, onBlur, classes = {}, ...props }) => {
  const textInputClasses = {
    [styles.textInput]: true,
    [styles.fullWidth]: fullWidth,
    [styles.error]: error,
    [classes]: typeof classes === 'string' || classes.input ? (classes.input || classes) : null,
  };

  return (
    <div className={cn(styles.container, classes.container)}>
      {Boolean(label) && <label className={cn(styles.label, classes.label)}>{label}</label>}
      <input
        value={val}
        className={cn(textInputClasses, classes)}
        type={type}
        placeholder={placeholder}
        onChange={e => onChange(e)}
        onFocus={onFocus}
        onBlur={onBlur}
        required={required}
        {...props}
      />
    </div>
  );
};

TextInput.propTypes = {
  val: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      container: PropTypes.string,
      label: PropTypes.string,
      input: PropTypes.string,
    }),
  ]),
};

export default TextInput;
